import { connect } from 'react-redux';
import systemMessageButton from '../component/system-message-header-button';
import { toggleMessageCenter } from './system-message-actions';

const mapStateToProps = state => ({
  messageCount: state.messageCenter.messageCount,
  redirectUrl: state.systemMessage.redirectUrl,
});

const mapDispatchToProps = {
  toggleMessageCenter,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(systemMessageButton);
